import initState from './initState';

export default {
  clearlogin(state, data){
    const initial = initState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
  setMentorDetail(state, data){
    state.mentorDetail = data
     console.log('setMentorDetail',data)
  },
  setUser(state, data) {
    state.user = data;
  },
  updateUser(state, data) {
    state.user[data.key] = data.value;
  },
  setMentorList(state,data){
    state.menTorList = data
  },
  setmodalReviewOpen(state,data){
    state.modalReviewOpen = data
  }
};
